import { useState, useEffect } from 'react';

export interface ProductStat {
  id: string;
  name: string;
  category: string;
  views: number;
  lastViewed: string;
}

const STATS_KEY = 'teknik_servis_stats';

export const useStats = () => {
  const [stats, setStats] = useState<ProductStat[]>([]);

  useEffect(() => {
    const stored = localStorage.getItem(STATS_KEY);
    if (stored) setStats(JSON.parse(stored));
  }, []);

  const recordView = (id: string, name: string, category: string) => {
    const stored = localStorage.getItem(STATS_KEY);
    const current: ProductStat[] = stored ? JSON.parse(stored) : [];
    const existing = current.find(s => s.id === id);
    let updated: ProductStat[];
    if (existing) {
      updated = current.map(s => s.id === id ? { ...s, views: s.views + 1, lastViewed: new Date().toISOString() } : s);
    } else {
      updated = [...current, { id, name, category, views: 1, lastViewed: new Date().toISOString() }];
    }
    localStorage.setItem(STATS_KEY, JSON.stringify(updated));
    setStats(updated);
  };

  const deleteStat = (id: string) => {
    const updated = stats.filter(s => s.id !== id);
    localStorage.setItem(STATS_KEY, JSON.stringify(updated));
    setStats(updated);
  };

  const getSortedStats = () => [...stats].sort((a, b) => b.views - a.views);

  return { stats, recordView, deleteStat, getSortedStats };
};
